import { useConfigStore } from '@/stores';
import { getDutyFreeFloorDescriptionMap } from '@/utils/duty-free';
import { findBuildingByMapId } from '@/utils/poi';
import { useMemo } from 'react';

export const useFloorCategory = (selectedFloorName?: string, currentMapBuildingId?: string) => {
    const buildings = useConfigStore((state) => state?.config?.server?.store?.buildings);

    // Resolve by map building id (needed for Jamsil multi-building), not kiosk home building
    const currentBuilding = useMemo(() => {
        if (!Array.isArray(buildings) || !currentMapBuildingId) {
            return null;
        }
        return findBuildingByMapId(buildings, currentMapBuildingId) || null;
    }, [buildings, currentMapBuildingId]);

    const selectedFloor = useMemo(() => {
        if (!currentBuilding || !selectedFloorName || !Array.isArray(currentBuilding?.floors)) {
            return null;
        }

        const floor = currentBuilding.floors.find((item) => item.name.ko === selectedFloorName);
        if (!floor) return null;

        const hardcodedDesc = getDutyFreeFloorDescriptionMap({
            storeCode: currentBuilding.storeCode,
            buildingType: String(currentBuilding.buildingType),
            floorName: floor.name.ko,
        });

        if (!hardcodedDesc) return floor;

        return {
            ...floor,
            lotteDescription: hardcodedDesc,
        };
    }, [currentBuilding, selectedFloorName]);

    return {
        selectedFloor,
    };
};
